import { render } from "./BaseTable.vue?vue&type=template&id=a6ca371a&scoped=true&ts=true"
import script from "./BaseTable.vue?vue&type=script&lang=ts"
export * from "./BaseTable.vue?vue&type=script&lang=ts"

import "./BaseTable.vue?vue&type=style&index=0&id=a6ca371a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ca371a"]])

export default __exports__